<template>
  <div class="account-quick-nav">
    <template v-if="isAuthenticated">
      <router-link v-if="!isPremium" class="account-link upgrade-link" to="/upgrade">Upgrade</router-link>
      <router-link class="account-link" to="/profile">Hi, {{ displayName }}</router-link>
      <router-link class="account-link" to="/stats">Stats</router-link>
      <router-link class="account-link" to="/settings">Settings</router-link>
    </template>
    <template v-else>
      <router-link class="account-link upgrade-link" to="/upgrade">Upgrade</router-link>
      <router-link class="account-link" to="/login">Sign in</router-link>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useAuthStore } from '../stores/auth';

export default {
  name: 'AccountQuickNav',
  setup() {
    const authStore = useAuthStore();

    const isAuthenticated = computed(() => authStore.isAuthenticated);
    const displayName = computed(() => authStore.displayName);
    const isPremium = computed(() => authStore.isPremium);

    const logout = () => authStore.logout();

    return {
      isAuthenticated,
      displayName,
      isPremium,
      logout
    };
  }
};
</script>

<style scoped>
.account-quick-nav {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.account-link {
  color: #c7c9c9;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
}

.account-link:hover {
  color: #fff;
}

.upgrade-link {
  background: linear-gradient(90deg, #F59E0B, #D97706);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  margin-right: 8px;
}

.logout {
  background: transparent;
  border: 1px solid #333;
  color: #c7c9c9;
  padding: 6px 10px;
  border-radius: 999px;
  cursor: pointer;
}
</style>
